export enum AgentClientType {
  Driver = "Driver",
  Workforce = "Workforce"
}
